import React from 'react'
import QuestionTpl from '../templates/QuestionTpl'
import { Select } from './Select'

const options = [
    {
        label: 'Petrol',
        value: 'petrol'
    },
    {
        label: 'Diesel',
        value: 'diesel'
    },
    {
        label: 'Electric',
        value: 'electric'
    },
    {
        label: 'PHEV (Petrol & Electric)',
        value: 'phev'
    }
];

export default class FuelTypeQn extends React.Component {

    static id = 'fuel_type';
    static defaultValue = options[0].value; // petrol

    render() {
        const { id, value, onChange } = this.props;

        return (
            <QuestionTpl
                {...this.props}
                title="Fuel type"
                description="The fuel type of the car"
                fineprint="What type of fuel do you put into your car?"
                component={Select}
                componentProps={{
                    options,
                    value,
                    onChange: (e) => onChange(id, e.target.value),
                }}
            />
        )
    }
}
